import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { lazy, Suspense, useState } from 'react'
import { Breadcrumbs } from '@/shared/ui/breadcrumbs'

// Панель детали грузится на переходе, форма правки — на первый клик: ни ту, ни
// другую стартовый бандл не тянет.
const ScenarioDetail = lazyRouteComponent(
  () => import('@/widgets/scenario-detail'),
  'ScenarioDetail',
)
const ScenarioForm = lazy(() =>
  import('@/widgets/scenario-form').then((m) => ({ default: m.ScenarioForm })),
)

export const Route = createFileRoute('/scenarios/$scenarioId')({
  component: ScenarioPage,
})

function ScenarioPage() {
  const { scenarioId } = Route.useParams()
  const [editOpen, setEditOpen] = useState(false)

  return (
    <>
      <Breadcrumbs current={scenarioId} />
      <ScenarioDetail scenarioId={scenarioId} onEdit={() => setEditOpen(true)} />
      {editOpen && (
        <Suspense fallback={null}>
          <ScenarioForm open scenarioId={scenarioId} onClose={() => setEditOpen(false)} />
        </Suspense>
      )}
    </>
  )
}
